import { REQUIREMENTS_KEY, requirementsReducer } from './RequirementsPane'
import { RESULTS_KEY, resultsReducer } from './ResultsPane'
import { combineReducers } from 'redux'

export const SIZER_CALCULATOR_KEY = 'SIZER_CALCULATOR'

export default combineReducers({
  [REQUIREMENTS_KEY]: requirementsReducer,
  [RESULTS_KEY]: resultsReducer
})